import { Button, Center, Checkbox, Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';

export type TBatchesSupervisionDataTableData = {
  primaryKey: string | number,
  id: string,
  label: string,
  seq: string | number,
  processingDate: string,
  startDate: string,
  endDate: string,
  status: string,
  [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
};

const columnHelper = createColumnHelper<TBatchesSupervisionDataTableData>();

export function getBatchesSupervisionDataTableColumns({
  isLoading,
  handleEdit,
}: Props) {
  return [
    columnHelper.accessor('id', {
      id: 'id',
      header: 'Id.',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('label', {
      id: 'label',
      header: 'Libellé',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('seq', {
      id: 'seq',
      header: 'Seq.',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('processingDate', {
      id: 'processingDate',
      header: 'Date Trait.',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('startDate', {
      id: 'startDate',
      header: 'Date Début',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('endDate', {
      id: 'endDate',
      header: 'Date Fin',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('status', {
      id: 'status',
      header: 'Statut',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.display({
      id: 'action',
      header: '',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>
              <Button
                size={'sm'}
                onClick={() => handleEdit(props.row)}
                mr={'1rem'}
              >
                Détail
              </Button>
              <Button
                size={'sm'}
                // onClick={() => handleEdit(props.row)}
                mr={'1rem'}
              >
                Err...
              </Button>
              <Button
                size={'sm'}
                // onClick={() => handleEdit(props.row)}
                mr={'1rem'}
              >
                Tra...
              </Button>
            </Center>
          </Skeleton>
        );
      },
    }),
  ];
}
